<script lang="ts" context="module">

    const formatter = new Intl.DateTimeFormat('default', {
        timeStyle: 'short',
        dateStyle: 'medium'
    });

</script>

<script lang="ts">

    export let date: string;

</script>

{date ? formatter.format(new Date(date)) : '-'}